<template>
  <header
    class="app-header"
    :class="{ 'app-header--border-bottom': borderBottom }"
  >
    <div
      class="app-header__content container"
      :class="{ 'app-header__content--landing-page': currentStep === 'landing-page' && !justifySpaceBetween }"
    >
      <!-- :class="{
        'on-landing-page' : currentStep === 'landing-page' && !justifySpaceBetween
      }" -->
      <a
        class="app-header__link"
        href="/"
      >
        <img
          class="app-header__logo"
          src="~@/assets/img/logo/cd-logo-black2x.png"
          alt="Canada Drives Logo"
        >
      </a>
      <transition
        name="fade"
        mode="out-in"
      >
        <div
          class="app-header__text"
          :class="inverted ? 'app-header__text--inverted' : 'app-header__text'"
        >
          <a
            class="app-header__link"
            :href="`tel:${phoneNumber}`"
          >{{ phoneNumber }}</a>
        </div>
      </transition>
    </div>
  </header>
</template>

<script>
export default {
  // Name
  name: 'app-header',

  // Props
  props: {
    borderBottom: Boolean,
    invertPhone: Boolean,
    justifySpaceBetween: Boolean
  },

  // Data
  data () {
    return {
      phoneNumber: '1-888-865-6402',
      inverted: true,
      currentStep: 'landing-page'
    }
  },

  // computed: {
  // isInverted () {
  //   currentStep == 'landing-page' && invertPhone
  // }
  // },

  mounted () {
    this.inverted = this.invertPhone
    this.$bus.$on('AppHeader:invert', (isInverted) => {
      this.inverted = isInverted
    })

    this.$bus.$on('AppHeader:stepChange', (currentStep) => {
      this.currentStep = currentStep
    })
  }

}
</script>

<style scoped lang="scss">
.app-header {
  z-index: 2;

  &--border-bottom {
    border-bottom: 2px solid #E6E6E6;

    @include breakpoint('desktop-up') {
      border-width: 1px;
    }
  }

  &__content {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    // width: 100%;
    height: 45px;
    margin: auto;
    color: $theme-text-grey-dark;

    // @media (min-width:768px) and (max-width: 1199px) {
    //   &.on-landing-page {
    //     justify-content: flex-start;
    //     padding-left: 40px;
    //   }
    // }

    // &.on-landing-page {
    //   @media (min-width:768px) {
    //     justify-content: flex-start;
    //   }
    // }

    @include breakpoint('tablet-portrait-up') {
      height: 65px;
      // justify-content: space-between;
    }

    // &:not(.on-landing-page) {
    //   a {
    //     color: #4A4A4A
    //   }
    // }

    @include breakpoint('desktop-up') {
      justify-content: space-between;
      // width: 1100px;
      // padding-left: 0;
    }

    // @media screen and (min-width: 1920px) {
    //   width: 1400px;
    // }

    &--landing-page {
      @include breakpoint('tablet-portrait-up') {
        justify-content: flex-start;
      }
      @include breakpoint('desktop-up') {
        justify-content: space-between;
      }
      // justify-content: center;
    }
  }

  .app-header__link {
    display: inline-block;
    text-decoration: none;
    color: $theme-text-grey-dark;
    font-weight: 600;
    font-size: 17px;
    transition: color 300ms ease-out;
  }

  &__logo {
    position: relative;
    width: 135px;
    margin: 0 auto;
    max-width: 100%;

    @include breakpoint('desktop-up') {
      width: 155px;
    }

  }

  // &__logo__white {

  //   @media (min-width: 1024px) {
  //     position: relative;
  //     left: 0;
  //     width: 155px;
  //   }
  // }

  &__text {
    font-size: 19px;
    font-family: $theme-font-family;
    display: none;

    @include breakpoint('desktop-up') {
      display: block;
    }
    &--inverted .app-header__link {
      color: #fff;
    }
  }

  // .app-header__text--inverted a{
  //   color: white;
  //   // @media (max-width: 1199px) {
  //   //   display: none;
  //   // }
  //   position: absolute;
  //   right: 40px;
  //   top: 20px;
  // }
}
</style>
